import { defineConfig } from '@twind/core';
import presetAutoprefix from '@twind/preset-autoprefix';
import presetTailwind from '@twind/preset-tailwind';
import * as colors from '@twind/preset-tailwind/colors';

export default defineConfig({
  hash: false,
  presets: [presetAutoprefix(), presetTailwind()],
  theme: {
    colors: {
      white: '#FFFFFF',
      blueGray: colors.slate,
      gray: colors.gray,
      red: colors.red,
      green: colors.green,
      cyan: colors.cyan,
      lightBlue: colors.blue,
      blue: colors.blue,
      indigo: colors.indigo,
      fuchsia: colors.fuchsia,
      pink: colors.pink,
    },
    extend: {
      fontFamily: {
        sans: ['Arial']
      },
      colors: {
        transparent: 'transparent',
        current: 'currentColor',
        white: '#FFFFFF',
        primary: '#56C7BB',
        'primary-hover': '#56C7BB',
        'blue-light': '#c1e3ff',
        '#305AC1': '#305AC1',
        '#D8E3FF': '#D8E3FF',
        '#6587DC': '#6587DC',

        // 主題色相關
        '#4EBCB1': '#4EBCB1',
        '#56C7BB': '#56C7BB',
        '#D5F5F2': '#D5F5F2',
        '#E8F3EF': '#E8F3EF',
        '#F2FCFB': '#F2FCFB',
        '#FAFCFB': '#FAFCFB',
        '#F2FBFA': '#F2FBFA',
        // 灰色相關
        '#5D5D5D': '#5D5D5D',
        '#D7D7D7': '#D7D7D7',
        '#636363': '#636363',
        '#B5B5B5': '#B5B5B5',
        '#F9F9F9': '#F9F9F9',
        '#FCFCFC': '#FCFCFC',
        '#F3F1F2': '#F3F1F2',
        '#F6F4F4': '#F6F4F4',
        '#9A9A9A': '#9A9A9A'
      },
      extend: {
        zIndex: {
          '-1': '-1',
          '-10': '-10',
          // navbar or footer
          '199': '199', // user navbar,
          '100': '100', // user navbar dropdown
          // modal
          '1000': '1000',
          // alert
          '2000': '2000',
          // loading
          '9000': '9000'
        }
      }
    }
  },
  plugins: [

  ],
});
